import { Tabs, TabsProps } from 'antd';
import React, { FC } from 'react';
import './styles.scss';

interface TabsSwitcherProps {
    items: TabsProps['items'];
    className: string;
    defaultActiveKey: string;
}

const TabsSwitcher: FC<TabsSwitcherProps> = ({ items, className, defaultActiveKey }) => {
    return (
        <Tabs defaultActiveKey={defaultActiveKey} animated items={items} className={className} />
    );
};
export default TabsSwitcher;
